/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const partnerPopup = () => {

  /**
   * Define things
   */
  const closeBtn = document.querySelector('.js-order-close');
  const popup = document.querySelector('.js-order-popup');
  const overlay = document.querySelector('.js-order-overlay');

  const closePopup = () => {
    document.querySelector('.js-order-popup.is-active').classList.add('is-fading-out');
    overlay.classList.add('is-fading-out');

    setTimeout(() => {
      document.querySelector('.js-order-popup.is-active').classList.remove('is-active', 'is-fading-out');
      overlay.classList.remove('is-active', 'is-fading-out');
    }, 300);
  }

  const showPopup = (e) => {
    let ajaxData = {
      action: 'get_partner_data',
      partner_id: e.target.dataset.id,
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function () {
        let result = JSON.parse(this.response);

        if (result.post_title) {
          document.querySelector('.js-partner-title').innerHTML = result.post_title;
        }

        let btn = document.querySelector('.js-partner-link');
        if (result.link) {
          btn.classList.remove('u-hidden');
          btn.href = result.link;
        } else {
          btn.classList.add('u-hidden');
        }

        if (result.long_description) {
          document.querySelector('.js-partner-long').innerHTML = result.long_description;
        }

        overlay.classList.add('is-active');
        popup.classList.add('is-active');
    };
    request.onerror = function () {
    };
    request.send(ajaxParameters);
  }

  /**
   * Run popup
   */
  const tease = document.querySelectorAll('.js-guest-with-popup');
  tease.forEach((btn) => {
    btn.addEventListener('click', showPopup);
  });

  /**
   * Handle popup closing
   */
  closeBtn.addEventListener('click', closePopup);
};

export default partnerPopup;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/partnerPopup.js